import { TIME_PERIODS, TimePeriod } from '../components/time-checkbox-group'

export const convertTimeRangeToPeriods = (
  timeRanges?:
    | Array<{ from: string | number; to: string | number }>
    | { from: string | number; to: string | number },
): TimePeriod[] => {
  if (!timeRanges) {
    return []
  }

  const rangesArray = Array.isArray(timeRanges) ? timeRanges : [timeRanges]

  if (rangesArray.length === 0) {
    return []
  }

  const periods: Set<TimePeriod> = new Set()

  rangesArray.forEach((timeRange) => {
    if (timeRange.from === 0 && timeRange.to === 0) {
      return
    }

    const from = Number(timeRange.from)
    const to = Number(timeRange.to)

    Object.entries(TIME_PERIODS).forEach(([period, range]) => {
      if (from === range.from && to === range.to) {
        periods.add(period as TimePeriod)
      }
    })
  })

  return Array.from(periods)
}

export const convertPeriodsToTimeRange = (
  periods: TimePeriod[],
): Array<{ from: number; to: number }> | undefined => {
  if (periods.length === 0) {
    return undefined
  }

  const ranges: Array<{ from: number; to: number }> = []

  periods.forEach((period) => {
    if (period !== TimePeriod.ANY) {
      const range = TIME_PERIODS[period as Exclude<TimePeriod, TimePeriod.ANY>]
      ranges.push({ from: range.from, to: range.to })
    }
  })

  return ranges.length > 0 ? ranges : undefined
}
